// Google Analytics 4. Universal Analytics (the old analytics.js and its
// UA- property) stopped collecting in July 2023, so this uses gtag.js.
//
// The measurement ID comes from REACT_APP_GA_MEASUREMENT_ID at build time,
// like the viewer's other switches: a build without one (local, UAT) loads
// nothing and every call here does nothing.
//
// Page views are sent by hand, with titles naming the project and camera, so
// "Page changes based on browser history events" must be off in the GA4
// property's enhanced measurement settings, or each page counts twice.

export const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || ''

export function loadAnalytics(id, page, projectsList) {
    if (!MEASUREMENT_ID) return
    if (!window.gtag) {
        window.dataLayer = window.dataLayer || []
        window.gtag = function gtag() {
            // gtag.js reads the arguments object itself, not an array
            window.dataLayer.push(arguments)
        }
        const script = document.createElement('script')
        script.async = true
        script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(MEASUREMENT_ID)}`
        document.head.appendChild(script)
        window.gtag('js', new Date())
    }
    window.gtag('config', MEASUREMENT_ID, {
        send_page_view: false,
        ...(id ? { user_id: String(id) } : {})
    })
    if (page) {
        trackPageChange(page, projectsList)
    }
}

export function trackPageChange(page, projectsList) {
    if (!window.gtag) return
    window.gtag('event', 'page_view', {
        page_path: page,
        page_location: `${window.location.origin}${page}`,
        page_title: formatPath(page, projectsList || [])
    })
}

/**
 * Send one event, e.g. trackEvent('zoom', { method: 'slider' }). Names and
 * parameter keys are snake_case, as GA4 expects. Does nothing until
 * analytics has loaded.
 */
export function trackEvent(name, params = {}) {
    if (!window.gtag) return
    window.gtag('event', name, params)
}

export function formatPath(path, projectsList) {
	const parts = path.split('/')
	if (parts.length === 2) {
		return "Camera Select";
	}
	const project = parseInt(parts[3], 10)
	let camera = parseInt(parts[5], 10)
	if (isNaN(project) || isNaN(camera)) {
		return path
	}
	camera = camera + 1 // convert 0-index to human friendly
	if (projectsList.length <= project) {
		return path
	}
	const projectName = projectsList[project].name
	if (parts[6] === 'timelapse') {
		return `${projectName}, Camera ${camera}: Timelapse`
	}
	let params
	if (parts.length === 7) {
		params = 'Latest'
	} else {
		params = parts.slice(7).join(' ')
	}
	return `${projectName}, Camera ${camera}: Photo (${params})`
}
